/* eslint-disable max-len */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApprovalDropdownComponent } from './approval-dropdown.component';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { SigningLawSectionDropdownModule } from '../../upload-memos/loa-customizer/signing-law-section-radio/signing-law-section-dropdown.module';
import { ProfileDisplayComponent } from '@shared/components/profile-display/profile-display.component';

@NgModule({
  declarations: [ApprovalDropdownComponent],
  exports: [ApprovalDropdownComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    SigningLawSectionDropdownModule,
    TranslateModule,
    ProfileDisplayComponent,
  ],
})
export class ApprovalDropdownModule {}
